// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-container {
    display: flex;
    justify-content: center;
    margin-top: 30px;
}

.profile-card {
    width: 400px;
    background: #ffffff;
    border-radius: 16px;
    padding: 24px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);

    display: flex;
    flex-direction: column;
    align-items: center;
}

.profile-picture {
    width: 128px;
    height: 128px;
    object-fit: cover;

    border-radius: 50%;
    border: 4px solid #4CAF50;

    margin-bottom: 16px;
}

.profile-display-name {
    margin: 0;
    font-size: 1.8rem;
    color: #333333;
}

.profile-username {
    margin-top: 6px;
    color: #777777;
    font-size: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/css/Home.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,0CAA0C;;IAE1C,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;;IAEjB,kBAAkB;IAClB,yBAAyB;;IAEzB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB","sourcesContent":[".profile-container {\n    display: flex;\n    justify-content: center;\n    margin-top: 30px;\n}\n\n.profile-card {\n    width: 400px;\n    background: #ffffff;\n    border-radius: 16px;\n    padding: 24px;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.profile-picture {\n    width: 128px;\n    height: 128px;\n    object-fit: cover;\n\n    border-radius: 50%;\n    border: 4px solid #4CAF50;\n\n    margin-bottom: 16px;\n}\n\n.profile-display-name {\n    margin: 0;\n    font-size: 1.8rem;\n    color: #333333;\n}\n\n.profile-username {\n    margin-top: 6px;\n    color: #777777;\n    font-size: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
